import script from "./AgentLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./AgentLogin.vue?vue&type=script&setup=true&lang=js"

import "./AgentLogin.vue?vue&type=style&index=0&id=7d5cd036&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d5cd036"]])

export default __exports__